module.exports = __webpack_public_path__ + "img/growcify-website-9-banner.a355021b.png";